import React from "react";
import styles from "./styles.css";
import Download from "./images/download.svg";
import { sendCustomGaEvents } from "../../../tracking";
import { downloadBrochureEvent } from "../../../constants/tracking-constants/franchise-ga";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import { BROCHURE_PDF } from "../../../constants/franchise-constants";

const FranchiseDownloadBrochure = () => {

    const onBrochureDownloadClick = async () => {
        window.open(BROCHURE_PDF, "_blank");
        await yieldToMain();
        sendCustomGaEvents(downloadBrochureEvent);
    };

    return (
        <div styleName={"styles.franchiseDownloadBrochure"} onClick={onBrochureDownloadClick}>
            Download Brochure
            <img src={Download} alt="Download" height={20} width={20} />
        </div>
    );
};

export default FranchiseDownloadBrochure;

